/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Divider from '@mui/material/Divider';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import useStyles from '../../MultiselectCheckbox.styles';

const renderIcon = (option, selectedOptions, allOptions, selected, theme) => {
  if (option.all) {
    if (selectedOptions.length === allOptions.length) {
      return (
        <CheckBoxIcon
          fontSize="medium"
          aria-hidden="true"
          sx={{ color: theme.palette.ebl.checkboxSelectedColor }}
        />
      );
    }
    if (
      selectedOptions.length > 0 &&
      selectedOptions.length < allOptions.length
    ) {
      return (
        <IndeterminateCheckBoxIcon
          fontSize="medium"
          aria-hidden="true"
          sx={{ color: theme.palette.ebl.checkboxPartialColor }}
        />
      );
    }
    return (
      <CheckBoxOutlineBlankIcon
        fontSize="medium"
        aria-hidden="true"
        sx={{ color: theme.palette.ebl.checkboxColor }}
      />
    );
  }

  return selected ? (
    <CheckBoxIcon
      fontSize="medium"
      aria-hidden="true"
      sx={{ color: theme.palette.ebl.checkboxSelectedColor }}
    />
  ) : (
    <CheckBoxOutlineBlankIcon
      fontSize="medium"
      aria-hidden="true"
      sx={{ color: theme.palette.ebl.checkboxColor }}
    />
  );
};

const ListOption = ({
  option,
  selectedOptions,
  allOptions,
  selected,
  multipleOptionsSelectedText,
  label,
  optionProps,
}) => {
  const { classes, theme, cx } = useStyles();
  const isAllOptionsSelected =
    option.all && selectedOptions.length === allOptions.length;

  const listOptionProps = {
    ...optionProps,
    // all option aria-selected doesn't update this value when selected
    ...(isAllOptionsSelected && { 'aria-selected': true }),
  };
  return (
    <React.Fragment key={option.key}>
      <li
        {...listOptionProps}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            marginRight: 8,
          }}
        >
          {renderIcon(option, selectedOptions, allOptions, selected, theme)}
        </span>
        <Typography
          variant={option.all ? 'sh2' : 'sh3'}
          className={cx({
            [classes.selectAllOption]: option.all,
          })}
        >
          {option.all ? (
            <FormattedMessage
              id="multiselectCheckbox.selectAllOption.labelText"
              values={{
                multipleOptions: multipleOptionsSelectedText,
                allOptionsCount: allOptions.length,
              }}
            />
          ) : (
            label
          )}
        </Typography>
      </li>
      {option.all ? (
        <Divider className={classes.divider} aria-hidden="true" />
      ) : null}
    </React.Fragment>
  );
};

ListOption.propTypes = {
  option: PropTypes.shape({
    all: PropTypes.bool,
    key: PropTypes.string,
  }).isRequired,
  selectedOptions: PropTypes.array.isRequired,
  allOptions: PropTypes.array.isRequired,
  selected: PropTypes.bool.isRequired,
  multipleOptionsSelectedText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  optionProps: PropTypes.object.isRequired,
};

export default ListOption;
